import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Collapse from "rc-collapse";
require("rc-collapse/assets/index.css");
const Panel = Collapse.Panel;
import loader from "../../assets/Loading_icon.gif";
import { URL, USER, platform } from "../../constants/constant";
import axios from "axios";

const PackageInfo = ({ setShowPackageInfo, showPackageInfo, packageId, city, pincode, packageName }) => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalTest, setTotalTests] = useState(0);

  useEffect(() => {
    getPackages();
  }, []);

  async function getPackages() {
    try {
    let accessToken = localStorage.getItem("user_short_token");
      const payload = {
        packageIds: [packageId],
      };
      let headers = {
        Accesstoken: accessToken,
        Platform: platform,
        pincode: pincode,
        city: city,
      };
      const res = await axios.post(URL.mb_wapi + "Labs/FetchPackageDetails", payload, { headers: headers });
      if (res.data.isSuccess) {
        let profilesRes = res.data.packages[0].availableProfiles;
        let availableTests = res.data.packages[0].availableTests;
        profilesRes.push({
            profileName: "Others",
            availableTests: availableTests
        })
        setProfiles(profilesRes);

        let total = 0;
        for (let p of profilesRes) {
          total = total + p.availableTests.length;
        }
        setTotalTests(total);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  return (
    <Modal size="md" aria-labelledby="contained-modal-title-vcenter" centered show={showPackageInfo} onHide={() => setShowPackageInfo(false)}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Package Details
          <div className="packageTotalCount">
            {totalTest} Lab Tests in {packageName}
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ height: "550px", padding: "5px", overflowY: "auto", display: "flex", flexDirection: "column", rowGap: "10px" }}>
        {loading ? (
          <img src={loader} />
        ) : (
          <Collapse accordion={true}>
            {profiles.map((data) => {
              return (
                <Panel header={data.profileName + " (" + data.availableTests.length + " Tests)"} style={{ fontWeight: "bold" }}>
                  {data.availableTests.length > 0 ? (
                    data.availableTests.map((test, j) => {
                      return (
                        <div key={j} style={{ padding: "4px 0", fontWeight: "300px !important" }}>
                          {test.testName}
                        </div>
                      );
                    })
                  ) : (
                    <p>No Tests found</p>
                  )}
                </Panel>
              );
            })}
          </Collapse>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default PackageInfo;
